/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Review/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import ReviewImage from './ReviewImage/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Review({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Review",
  images,
  handleReset
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Review.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Review.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(images) && images.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="image"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/ReviewImage(${item?.id ?? item?._id ?? index})`}
      >
<ReviewImage
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/ReviewImage(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 alignSelf="center"
 onClick={handleReset}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Start over"
/>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }